import { render } from "./StoreDiscountInformation.vue?vue&type=template&id=80acba98"
import script from "./StoreDiscountInformation.vue?vue&type=script&lang=js"
export * from "./StoreDiscountInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__